<template>
  <div class="remedios">
    <div class="row">
      <div class="container imagens-logo">
        <div class="col-xs-12">
          <img
            class="img-logo-remedio"
            :src="require('@/assets/css/img/logo-remedio-facil.png')"
            alt="Uma representação de um remédio com um símbolo positivo"
          />
        </div>
      </div>
      <PublicHeader title="Remédio Fácil" :showTitle="false">
        <div class="col-xs-12 col-sm-6 col-md-5">
          <p class="subheader">
            Encontre os medicamentos da Relação Municipal de Medicamentos -
            REMUME, disponíveis em uma das Policlínicas, CAPSs e AMBESPs do
            município de Santos.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb :links="[{ label: 'Remédio Fácil' }]" />
        <div class="row form-group">
          <div class="col-xs-12">
            <h3>
              Pesquise pelo nome genérico / princípio ativo do medicamento
            </h3>
          </div>
          <div class="col-sm-6">
            <div class="input-group form-group">
              <input
                type="text"
                ref="descricao"
                name="descricao"
                id="descricao"
                placeholder="Ex.: Paracetamol, dipirona, losartan...."
                v-model="termoBusca"
                v-validate="'required|min:3'"
                :class="[
                  'form-control',
                  'input-pesquisar',
                  { 'is-danger': errors.has('descricao') }
                ]"
                @keyup.enter="consultar()"
              />
              <span class="input-group-btn">
                <button
                  class="btn btn-default btn-pesquisar"
                  type="button"
                  title="Pesquisar"
                  @click="consultar()"
                  :disabled="carregando"
                >
                  <font-awesome-icon
                    v-if="carregando"
                    :icon="'spinner'"
                    alt="Ícone giratório representando a espera de carregamento"
                    spin
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    :icon="'search'"
                    alt="Ícone de uma lupa representando a ação de pesquisar"
                  ></font-awesome-icon>
                </button>
              </span>
            </div>
            <button
              class="btn btn-default"
              v-if="remedios.length"
              @click="limparConsulta()"
            >
              <font-awesome-icon :icon="'times'" /> Limpar
            </button>
            <small v-if="errors.has('descricao')" class="" style="">
              <span class="is-danger">
                <font-awesome-icon :icon="'exclamation-triangle'" />&nbsp;
                {{ getErrors.descricao }}
              </span>
            </small>
          </div>
        </div>
        <div class="row" v-if="retornoVazio">
          <div class="col-xs-12">
            <p class="text-center">
              Nenhum resultado encontrado para o critério de busca.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-3" v-for="remedio in remedios">
            <router-link
              :to="{
                name: 'unidades-remedio',
                params: { principio: remedio.principio_ativo, remedio }
              }"
            >
              <div class="card card-remedios">
                {{ remedio.principio_ativo }}
                <span v-if="remedio.portaria === '344/98'">
                  Medicamento Controlado - Portaria 344/98
                </span>
                <span v-if="remedio.portaria === '471/2021'">
                  Medicamento Antimicrobiano - RDC 471/2021
                </span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h3>
              Orientações para prescrição e dispensação de medicamentos da
              Relação Municipal de Medicamentos - REMUME
            </h3>
            <ol class="font-lg">
              <li>
                Serão aceitas receitas em nome de munícipes e provenientes de
                Unidades de Saúde pertencentes ao Sistema Único de Saúde (SUS)
                ou conveniadas a rede municipal; (Portaria SMS 27/2023)
              </li>
              <li>
                A dispensação de medicamentos nas Unidades do SUS sob gestão
                Municipal deverá ocorrer mediante a apresentação dos seguintes
                documentos: receita impressa do munícipe e documento com foto do
                responsável pela retirada; excetua-se a esta regra as
                prescrições com assinatura digital para as quais não é
                obrigatória a apresentação da receita impressa; (Portaria SMS
                27/2023)
                <ol class="alpha">
                  <li>
                    Em caso de retirada de Medicamentos por pessoas entre 16 e
                    18 anos em que a receita não seja do responsável pela
                    retirada, deverá ser apresentado também um documento com
                    foto do paciente.
                  </li>
                </ol>
              </li>
              <li>
                Caso o medicamento seja de Uso Contínuo, deve constar tal
                informação na Receita;
                <ol class="alpha">
                  <li>
                    Medicamentos de Uso Contínuo serão fornecidos para períodos
                    de 30 dias, sendo a validade da receita de 6 meses. Exceto
                    para os Medicamentos controlados da Portaria 344/98;
                  </li>
                </ol>
              </li>
              <li>
                Medicamentos da Portaria 344/98 devem ser prescritos em duas
                vias (via da farmácia e via do usuário) e a receita tem validade
                de 30 dias
                <ol class="alpha">
                  <li>
                    Medicamentos da Lista A - necessitam de notificação de
                    receita A + prescrição em duas vias;
                  </li>
                  <li>
                    Medicamentos da Lista B - necessitam de notificação de
                    receita B + prescrição em duas vias;
                  </li>
                </ol>
              </li>
              <li>
                Antimicrobianos pertencentes a RDC 471/2021 devem ser prescritos
                em duas vias (via da farmácia e via do usuário), sendo a
                validade da receita de 10 dias.
              </li>
              <li>
                Pacientes insulinodependentes ficam vinculados a sua unidade de
                origem para a retirada de insumos e Insulinas
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PublicHeader, Breadcrumb } from '../../../components'
import { request } from '../../../request'

export default {
  components: {
    PublicHeader,
    Breadcrumb
  },
  name: 'remedios',
  data() {
    return {
      carregando: false,
      retornoVazio: false,
      remedios: [],
      termoBusca: ''
    }
  },
  methods: {
    toggleLoading() {
      this.carregando = !this.carregando
    },
    getErrorByKey(key) {
      const { items } = this.errors

      const filter = item => item.field === key

      const [descricao] = items.filter(filter)
      return descricao || {}
    },
    consultar() {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$toastr.e(this.getErrors.descricao)
          return
        }

        this.toggleLoading()
        request
          .get('remedios/pesquisa', { params: { term: this.termoBusca } })
          .then(({ data }) => {
            this.remedios = data
            this.retornoVazio = !data.length
          })
          .catch(error => {
            console.log(error.response)
            this.$toastr.e('Houve um erro na consulta. Tente novamente')
          })
          .finally(this.toggleLoading)
      })
    },
    limparConsulta() {
      this.remedios = []
      this.termoBusca = ''
      this.$refs.descricao.focus()
    }
  },
  computed: {
    getErrors() {
      const descricao = this.getErrorByKey('descricao')

      let errorDesc = ''

      switch (descricao.rule) {
        case 'required':
          errorDesc = 'Por favor digite o nome ou princípio ativo do remédio'
          break

        case 'min':
          errorDesc = 'Por favor digite ao menos 3 caracteres para consulta'
          break
      }

      return { descricao: errorDesc }
    }
  }
}
</script>

<style type="text/css" scoped>
.input-group-btn > .btn.btn-default {
  border: 1px solid #468c36;
}

.imagens-logo {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: -30px;
}

.img-logo-remedio {
  max-height: 250px;
  margin-left: -40px;
}
.img-logo-pms {
  max-height: 100px;
}
ol {
  padding-left: 20px;
}

ol > li {
  margin-bottom: 15px;
}
ol.alpha > li {
  list-style: lower-alpha;
  margin-top: 15px;
}
ol > li::marker {
  font-weight: 600;
}
.card-remedios {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-remedios > span {
  color: #ff3860;
  font-weight: 600;
}

@media (max-width: 767px) {
  .input-pesquisar,
  .btn-pesquisar {
    height: 50px;
  }

  .input-pesquisar {
    font-size: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/remedios/index.vue